// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3tVnj","content":"GlobalSearch_content__2SJNb"};